// extracted by mini-css-extract-plugin
export default {"readMore":"styles_readMore__FnLAX","collapsed":"styles_collapsed__wsOjC","expanded":"styles_expanded__SEFZO"};